import React  from 'react';
import styled from 'styled-components';
import backgroundImage from '../images/boy-child-childhood-6459.jpg';

const Div = styled.div`
    position:fixed;
    left:0px;
    top:0px;
    width:100%;
    height:100%;
    background-image: url(${backgroundImage});
    background-size:cover;
    z-index:0;
`;

const Background = () => (
  <Div primary>
  	<div className="container" id="content">
  	</div>
  </Div>
);

export default Background;


// WEBPACK FOOTER //
// ./src/components/background.component.js